"use client"

import { Info } from "lucide-react"
import { useTranslation } from "react-i18next"

type LegalNoticeKind = "pilot" | "ai" | "jobEdit"

export function LegalNotice({ kind }: { kind: LegalNoticeKind }) {
  const { t, i18n } = useTranslation("legal")
  const isRTL = i18n.language === "ar"

  return (
    <div
      className={`flex gap-3 rounded-md border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-950 ${
        isRTL ? "flex-row-reverse text-right" : "text-left"
      }`}
      role="note"
    >
      <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <p>{t(`notices.${kind}`)}</p>
    </div>
  )
}